module.exports = __webpack_public_path__ + "static/media/treatment-OFF.ced2edbe.svg";